export { default } from './ListItemText';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ListItemText/index.js
// module id = 689
// module chunks = 0